import { NavLink } from 'react-router-dom';
import type { ReactNode } from 'react';

interface NmChipNavProps {
  to: string;
  code?: string;
  label: string;
  driftPx?: number;
  className?: string;
}

/**
 * Studio nav chip — optional code / label with optional micro drift (CSS only).
 */
export function NmChipNav({ to, code, label, driftPx = 0, className = '' }: NmChipNavProps) {
  return (
    <NavLink
      to={to}
      style={{ transform: `translateY(${driftPx}px)` }}
      className={({ isActive }) =>
        `inline-flex min-w-0 items-baseline gap-1 rounded-full border px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.14em] transition-colors ${className} ${
            isActive
            ? 'border-transparent bg-nm-accent text-nm-on-accent'
            : 'border-nm-border text-nm-muted hover:border-nm-muted hover:text-nm-ink'
        }`
      }
    >
      {code ? (
        <>
          <span className="text-nm-muted">{code}</span>
          <span className="text-[10px] text-nm-muted">/</span>
        </>
      ) : null}
      <span>{label}</span>
    </NavLink>
  );
}

interface NmChipButtonProps {
  children: ReactNode;
  onClick?: () => void;
  variant?: 'outline' | 'accent';
  className?: string;
}

export function NmChipButton({
  children,
  onClick,
  variant = 'outline',
  className = '',
}: NmChipButtonProps) {
  const base =
    'rounded-full border px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.12em] transition-colors';
  const styles =
    variant === 'accent'
      ? 'border-nm-accent/40 bg-nm-accent text-nm-on-accent hover:bg-nm-accent-hover'
      : 'border-nm-border text-nm-muted hover:border-nm-muted hover:text-nm-ink';
  return (
    <button type="button" onClick={onClick} className={`${base} ${styles} ${className}`}>
      {children}
    </button>
  );
}
